"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncJobStatus = void 0;
/** Stored on `AsyncJob.status` (string column); values use kebab-case. */
var AsyncJobStatus;
(function (AsyncJobStatus) {
    AsyncJobStatus["Pending"] = "pending";
    AsyncJobStatus["InProgress"] = "in-progress";
    AsyncJobStatus["Complete"] = "complete";
    AsyncJobStatus["Failed"] = "failed";
})(AsyncJobStatus || (exports.AsyncJobStatus = AsyncJobStatus = {}));
